
<template>
	<div class="comp">
		<el-dialog title="修改个人信息" width="480px" :visible="dialogState" @close="close" :close-on-press-escape="false" :wrapperClosable="false" :modal-append-to-body="false" :close-on-click-modal="false">
			<el-form label-width="80px">
				<el-form-item label="昵称:">
					<el-input v-model="nickname" style="width:300px;" ></el-input>
				</el-form-item>
				<el-form-item label="性别:">
					<el-radio-group v-model="sex">
						<el-radio label="男"></el-radio>
						<el-radio label="女"></el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="生日:">
					<el-date-picker type="date" placeholder="选择日期" v-model="birthday" style="width:300px;"></el-date-picker>
				</el-form-item>
			</el-form>
			<div class="submit" @click="submit">保存</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dialogState:true,
				
				nickname:'',
				sex:'',
				birthday:'',
			}
		},
		props:{
			userDetail:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.nickname=this.userDetail.nickName
			this.sex=this.userDetail.sex||''
			this.birthday=this.userDetail.birthday?new Date(this.userDetail.birthday*1000):''
		},
		methods:{
			close(){
				this.$emit("submit",{type:'close'})
			},
			submit(){
				if(this.$public.isNull(this.nickname)){
					this.$message({
						type: 'error',
						message: '昵称输入有误'
					});
					return 
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_livingMall+'/api/User/update/Info', {
					"userId": this.userDetail.userId,
					"nickName": this.nickname,
					"sex": this.sex,
					"bron": this.$public.FTimeStr10(this.birthday),
					"avatarPic": this.userDetail.avatarPic,
				}).then(res => {
					loading.close()
					if(res.code==0){
						this.$emit("submit",{type:'success'})
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.comp{
		.submit{
			background-color:#FCD000 ;border-radius: 24px;text-align: center;line-height: 48px;width:385px;font-size: 18px;color:#303042;margin:50px auto 20px;cursor: pointer;
		}
	}
</style>
